import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./plugins/axios";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import "./assets/scss/index.scss";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import qs from "qs";
import io from "socket.io-client";
import mitt from "mitt";
import DatePic from "vue-datepicker-next";
import "vue-datepicker-next/index.css";
import LoadingItem from "./components/LoadingItem.vue";
//PrimeVue
import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";
import Editor from "primevue/editor";

const socket = "";

const app = createApp(App);

//전역 component
app.component("LoadingItem", LoadingItem);
app.component("VPagination", VPagination);
app.component("DatePic", DatePic);
app.component("Editor", Editor);

const notify = (data) => {
  toast(data.text, {
    type: data.type,
    theme: "light",
    autoClose: 1000,
  }); // ToastOptions
};
let emitter = mitt();
// 전역함수 등록
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$notify = notify;
app.config.globalProperties.$qs = qs;
app.config.globalProperties.$emitter = emitter;
app.config.globalProperties.$socket = socket;

//전역 함수
app.config.globalProperties.$refreshPage = function () {
  // 새로고침
  this.$nextTick(() => {
    window.location.reload();
  });
};

app.config.globalProperties.$addCommas = function (num) {
  if (num == null) {
    return;
  }
  return num
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    .replace(/^(-?\d+)(\d{3})/, "$1,$2");
};
app.config.globalProperties.$delCommas = function (num) {
  if (num == null) {
    return;
  }
  return num.toString().replace(/,/g, "");
};

app.config.globalProperties.$openWindow = (e, key, width, height) => {
  if (window.innerWidth > 1000) {
    var left = window.innerWidth / 2 - width / 2;
    var top = window.innerHeight / 2 - height / 2;
  } else {
    var left = 0;
    var top = 0;
  }

  return window.open(
    e,
    `view_${key}`,
    `height=${height},width=${width},menubar=no,toolbar=no,location=no,resizable=yes,status=no,scrollbars=no,left=${left}, top=${top}`
  );
};

app.use(store).use(router).use(PrimeVue).mount("#app");
